import React from 'react';
import './ViewProductsModal.css';
import { useTranslation } from 'react-i18next';

import Modal from '../Modal/Modal';
import { formatDate } from "../../utils/Helper";


const ViewProductsModal = ({ show, setShow, data }) => {
	const { t } = useTranslation();

	// Get display amount for a livraison (handles both old and new format)
	const getDisplayAmount = (elem) => {
		if (elem?.net_amount !== undefined) {
			return elem.net_amount;
		}
		return elem?.sell_price || 0;
	};

	// Get product display for a livraison
	const getProductDisplay = (elem) => {
		if (elem?.items && elem.items.length > 0) {
			if (elem.items.length === 1) {
				return elem.items[0]?.stock_id?.product_name || "-";
			}
			return `${elem.items.length} ${t("produits")}`;
		}
		// Fallback for old format
		if (elem?.stock_id?.product_name) {
			return elem.stock_id.product_name;
		}
		// Another fallback for confirmation_details format
		if (elem?.confirmation_details?.length > 0) {
			return elem.confirmation_details.map(d => d?.stock_id?.product_name).filter(Boolean).join(", ");
		}
		return "-";
	};


	return (
		<Modal className="full-w-modal" showBakcDrop={show} modal={show} hideModal={() => { setShow(false) }}>
			<div className="table_section table_section_products_modal">
				<table cellPadding="0" cellSpacing="0">
					<tbody>
						<tr>
							<td className="table-keys cell2 pointer">{t("Réf")}</td>
							<td className="table-keys cell2 pointer">{t("Date")}</td>
							<td className="table-keys cell2 pointer">{t("Produits")}</td>
							<td className="table-keys cell2 pointer">{t("Destinataire")}</td>
							<td className="table-keys cell2 pointer">{t("Adresse")}</td>
							<td className="table-keys cell2 pointer">{t("Tel")}</td>
							<td className="table-keys cell2 pointer">{t("Montant")}</td>
						</tr>

						{
							data?.map((elem, i) => (
								<tr className={`data-cells`} key={elem?._id || i}>
									<td className={`value2 cell2`} style={{ fontSize: "11px", color: "#666" }}>
										{elem?.reference || elem?._id?.slice(-6)}
									</td>
									<td className={`value2 cell2`}>
										{formatDate(elem?.created)}
									</td>
									<td className={`value2 cell2 rm_wrap`}>
										{getProductDisplay(elem)}
										{elem?.total_returns > 0 && (
											<span style={{
												marginLeft: "5px",
												color: "#ef4444",
												fontSize: "10px",
												backgroundColor: "#fee2e2",
												padding: "2px 4px",
												borderRadius: "3px"
											}}>
												{t("retour")}
											</span>
										)}
									</td>
									<td className={`value2 cell2`}>{elem?.buyer}</td>
									<td className={`value2 cell2 rm_wrap`}>{elem?.adresse}</td>
									<td className={`value2 cell2`}>{elem?.buyer_phone}</td>
									<td className={`value2 cell2`}>
										<div className="flex flex-col">
											<span style={{ fontWeight: "bold" }}>{getDisplayAmount(elem)} {t("MAD")}</span>
											{elem?.total_returns > 0 && (
												<span style={{ fontSize: "10px", color: "#ef4444" }}>
													(-{elem.total_returns} {t("retours")})
												</span>
											)}
										</div>
									</td>
								</tr>
							))
						}

					</tbody>
				</table>
			</div>
		</Modal>
	)
}

export default ViewProductsModal